import styled from "@emotion/styled";
import { IconContainer as SocialButtonIconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  ActionContainer as SignUpNewsletterActionContainer,
  Container as SignUpNewsletterContainer,
  Title as SignUpNewsletterTitle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  CheckEmailMessage as SignUpSuccessCheckEmailMessage,
  IconContainer as SignUpSuccessIconContainer,
  Title as SignUpSuccessTitle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontRobotoCondensed } from "shared/lib/styles";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "landscape",
  root: {
    containerSize: "medium",
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: false,
    summaryFontStyle: "small",
    titleFontStyle: "small",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: true,
    hasSeeMoreLinks: false,
    titleFontStyle: "medium",
  },
};

type ContainerProps = {
  theme?: ThemeType;
};

export const Container = styled.div<ContainerProps>`
  ${SignUpNewsletterContainer} {
    justify-items: flex-start;

    text-align: start;
    ${SignUpNewsletterTitle} {
      max-inline-size: 382px;

      color: #00001f;
      font-size: 18px;
      font-family: ${fontRobotoCondensed};
      line-height: 21px;
    }
  }

  ${SignUpSuccessCheckEmailMessage}, ${SignUpSuccessTitle} {
    color: #00001f;
  }
  ${SignUpSuccessCheckEmailMessage} {
    margin-block-end: 0;
    padding-block-start: 8px;
  }
  ${SignUpSuccessIconContainer} {
    margin-block-end: 0;
  }

  ${SocialButtonIconContainer} {
    background-color: #ffffff;
  }
  ${SignUpNewsletterActionContainer} {
    justify-self: center;
  }
`;
